import { render, staticRenderFns } from "./SectionNavigator.vue?vue&type=template&id=d2dd0bb2"
import script from "./SectionNavigator.vue?vue&type=script&lang=js"
export * from "./SectionNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports